var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#62BEE7;}\n\t.st1{fill:#474E5E;}\n\t.st2{fill:#F3EEE4;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#E8DCCA;}\n\t.st5{opacity:0.1;fill:#231F20;}\n\t.st6{fill:#506268;}\n\t.st7{fill:#EB5151;}\n\t.st8{fill:#C64444;}\n\t.st9{fill:#9CCB5B;}\n\t.st10{fill:#404A4C;}\n\t.st11{fill:#676767;}\n\t.st12{fill:#E0E1E5;}\n\t.st13{fill:#9D9EA0;}\n\t.st14{fill:#B3B4B7;}\n\t.st15{opacity:0.1;}\n\t.st16{fill:#231F20;}\n\t.st17{fill:#FACC20;}\n\t.st18{fill:#FDEF34;}\n\t.st19{fill:#F7A90B;}\n\t.st20{fill:#20B8EA;}\n\t.st21{fill:#00A8EA;}\n\t.st22{fill:#33D3F4;}\n\t.st23{opacity:0.25;fill:#FFFFFF;}\n\t.st24{fill:#CACBCE;}\n\t.st25{fill:#2E3545;}\n\t.st26{fill:#8DAF4A;}\n\t.st27{fill:#F9C2AF;}\n\t.st28{fill:#AFDDF4;}\n\t.st29{fill:#677177;}\n\t.st30{fill:#FFEDB3;}\n\t.st31{fill:#695652;}\n\t.st32{fill:#30A7BF;}\n\t.st33{fill:#4D5556;}\n\t.st34{opacity:0.35;}\n\t.st35{fill:#FFCB04;}\n\t.st36{fill:#99E9FA;}\n\t.st37{opacity:0.2;}\n\t.st38{opacity:3.000000e-02;}\n\t.st39{fill:#9ECA5B;}\n\t.st40{fill:#98BA56;}\n\t.st41{fill:#40EEFF;}\n\t.st42{fill:#FF6A52;}\n\t.st43{opacity:0.1;fill:#FFFFFF;}\n\t.st44{opacity:0.4;}\n\t.st45{fill:#57606D;}\n\t.st46{fill:#BACA5B;}\n\t.st47{opacity:0.25;}\n\t.st48{opacity:5.000000e-02;fill:#231F20;}\n\t.st49{opacity:0.2;fill:#FFFFFF;}\n\t.st50{opacity:0.3;}\n\t.st51{fill:#FFD82F;}\n\t.st52{fill:#F4C121;}\n\t.st53{fill:#EF9D0A;}\n\t.st54{fill:#F9E532;}\n\t.st55{fill:#F4C01E;}\n\t.st56{fill:#FFE14D;}\n\t.st57{fill:#B7C156;}\n\t.st58{fill:#DBA92C;}\n\t.st59{fill:#363D4D;}\n\t.st60{fill:#3F4656;}\n\t.st61{fill:#463E33;}\n\t.st62{fill:none;}\n\t.st63{opacity:4.000000e-02;}\n\t.st64{fill:#4DB6AC;}\n\t.st65{fill:#CADE49;}\n\t.st66{fill:#9FD343;}\n\t.st67{fill:#AAD643;}\n\t.st68{fill:#82C736;}\n\t.st69{opacity:0.3;fill:#FFFFFF;}\n\t.st70{fill:#FFD640;}\n\t.st71{opacity:0.5;}\n\t.st72{opacity:0.6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 20.6,
    width: 27.7,
    x: 18.5,
    y: 21.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 4.4,
    width: 45.7,
    x: 9.2,
    y: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 4.4,
    width: 41.3,
    x: 11.4,
    y: 42.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    height: 14.7,
    width: 4.4,
    x: 15.8,
    y: 24.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    height: 2.9,
    width: 7.4,
    x: 14.3,
    y: 21.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    height: 2.9,
    width: 7.4,
    x: 42.3,
    y: 39.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    height: 2.9,
    width: 7.4,
    x: 14.3,
    y: 39.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    height: 2.9,
    width: 7.4,
    x: 42.3,
    y: 21.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    height: 1.3,
    width: 7.4,
    x: 14.3,
    y: 21.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    height: 1.3,
    width: 7.4,
    x: 42.3,
    y: 21.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "10.6,17.1 32,5.3 53.4,17.1 53.4,21.5 10.6,21.5   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "13.8,19.6 13.8,19.2 32.6,8.8 51.5,19.2 51.5,19.6   "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 32.6,
    cy: 14.2,
    r: 2.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "33.3,9.5 51.5,19.5 51.5,19.2 32.6,8.8 13.8,19.2 13.8,19.6 14.9,19.6   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32,11.3c-1.3,0-2.3,1-2.3,2.3c0,0.6,0.3,1.2,0.7,1.6l3.3-3.3C33.2,11.5,32.6,11.3,32,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.4,15.2c0.4,0.4,1,0.7,1.6,0.7c1.3,0,2.3-1,2.3-2.3c0-0.6-0.3-1.2-0.7-1.6L30.4,15.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    height: 1.3,
    width: 7.4,
    x: 14.3,
    y: 21.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    height: 1.3,
    width: 7.4,
    x: 42.3,
    y: 21.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    height: 1.3,
    width: 7.4,
    x: 14.3,
    y: 40.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    height: 1.3,
    width: 7.4,
    x: 42.3,
    y: 40.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    height: 1.3,
    width: 45.7,
    x: 9.2,
    y: 49.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    height: 1.3,
    width: 41.3,
    x: 11.4,
    y: 45.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.2,42.1v-9.4c0-2.8-2.3-5.2-5.2-5.2c-2.8,0-5.2,2.3-5.2,5.2l0,9.4H37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M32.3,28.2c1,0.1,1.9,0.5,2.6,1.1l-2.6,2.6V28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M31.7,31.9l-2.6-2.6c0.7-0.6,1.6-1,2.6-1.1V31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M35.4,29.7c0.6,0.7,1,1.6,1.1,2.6h-3.7L35.4,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M28.6,29.7l2.6,2.6h-3.7C27.6,31.3,28,30.4,28.6,29.7z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st7",
    height: 9.2,
    width: 4.5,
    x: 27.5,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    height: 9.2,
    width: 4.5,
    x: 32,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    height: 14.7,
    width: 4.4,
    x: 43.8,
    y: 24.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    height: 14.7,
    width: 2.2,
    x: 46,
    y: 24.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    height: 14.7,
    width: 2.2,
    x: 18,
    y: 24.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalIcon);
export default __webpack_public_path__ + "static/media/legal_icon.c9b471b54b1d7d9da55f35bcaa4b2484.svg";
export { ForwardRef as ReactComponent };